import cart from '@ppcp/cart';
import Actions from '@ppcp/actions';
import {getPaymentMethod} from '@ppcp/payment-methods';
import FastlaneCheckout from "../gateways/FastlaneGateway";

const fastlane = new FastlaneCheckout({
    cart,
    actions: new Actions(),
    settings: wc_ppcp_fastlane_params,
    cardGateway: getPaymentMethod('ppcp_card')
});

fastlane.initialize();